var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "userSetting__container" }, [
    _c("h1", { staticClass: "userSetting__title" }, [_vm._v("個人設定")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui bottom attached tab segment active",
        attrs: { "data-tab": "info" },
      },
      [
        _c("edit-profile"),
        _vm._v(" "),
        _c("div", { staticClass: "userSetting__unsubscribeContainer" }, [
          _c("h2", { staticClass: "userSetting__sectionTitle" }, [
            _vm._v("退会をご希望される場合"),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.leaveNow,
                  expression: "!leaveNow",
                },
              ],
              staticClass: "ui button negative",
              on: {
                click: function ($event) {
                  _vm.leaveNow = true
                },
              },
            },
            [_vm._v("グルメプラスを退会する")]
          ),
          _vm._v(" "),
          _vm.leaveNow
            ? _c("div", { staticClass: "userSetting__unsubscribeConfirm" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ui button",
                    on: {
                      click: function ($event) {
                        _vm.leaveNow = false
                      },
                    },
                  },
                  [_vm._v("退会をキャンセル")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ui button negative",
                    class: { "loading disabled": _vm.leaveForm.waiting },
                    on: { click: _vm.leave },
                  },
                  [_vm._v("退会する")]
                ),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui bottom attached tab segment",
        attrs: { "data-tab": "password" },
      },
      [_c("change-password")],
      1
    ),
    _vm._v(" "),
    false
      ? _c(
          "div",
          {
            staticClass: "ui bottom attached tab segment",
            attrs: { "data-tab": "sns" },
          },
          [
            _c("p", [
              _vm._v("SNSと連携すると、ログインを簡単に行うことができます"),
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui top attached tabular menu" }, [
      _c("a", { staticClass: "item active", attrs: { "data-tab": "info" } }, [
        _vm._v("会員情報"),
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "item", attrs: { "data-tab": "password" } }, [
        _vm._v("パスワード"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui warning message" }, [
      _c("div", { staticClass: "header" }, [
        _vm._v(
          "\n            コンシェルジュとのチャットなどが全て削除されます\n          "
        ),
      ]),
      _vm._v(
        "\n          この操作は取り消せません。本当に退会しますか？\n        "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui cards" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "header" }, [
            _c("i", {
              staticClass: "inverted facebook icon",
              staticStyle: { color: "#3b5998" },
            }),
            _vm._v(" Facebook"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ui bottom attached button primary" }, [
          _c("i", { staticClass: "add icon" }),
          _vm._v("\n          連携する\n        "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ui cards" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "header" }, [
            _c("i", {
              staticClass: "inverted facebook icon",
              staticStyle: { color: "#3b5998" },
            }),
            _vm._v(" Facebook"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _c("a", { attrs: { href: "" } }, [_vm._v("{user name}で連携中")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ui bottom attached button" }, [
          _c("i", { staticClass: "close icon" }),
          _vm._v("\n          連携を解除する\n        "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }